import { CompanyProduct } from "models/StatisticsReport";

const getProductsFromIds = (products:CompanyProduct[], ids:string[] | string) => {
    const idArray = Array.isArray(ids) ? ids : [ids];
    const now = new Date();

    return products.filter((product) => {
        const isIdMatch = idArray.includes(product.productId);
        const startDate = new Date(product.startDate);
        const endDate = new Date(product.endDate);
        return isIdMatch && now >= startDate && now <= endDate;
    }).map((product) => {
        try {
            const parsed = JSON.parse(product.payload);
            return parsed.Items || [];
        } catch (error) {
            console.log('Failed');
            return [];
        }
    }).flat();
}

export default getProductsFromIds;